export const CopyToClipboard = value => {

    const textArea = document.createElement("textarea")

    textArea.value = value
    textArea.style.top = "0"
    textArea.style.left = "0"
    textArea.style.position = "fixed"

    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    try {
        document.execCommand('copy')
    } catch (err) {

    }

    document.body.removeChild(textArea)
}
